/// <reference path="../../../../../../../scripts/typings/sweetalert/sweetalert.d.ts" />

module Tapas.ViewModels {
    export class CustomerCenterViewModel extends Ftw.ViewModels.BaseViewModel {
        public UserDataService = new Ftw.Dataservice.UserDataservice();        
        public data = new Ftw.Data();
        public UserContacts = ko.observableArray([]);
        public OrderTemplateDetailsLink = ko.observable('');
        public OrderTemplateList = ko.observableArray([]);
        public OrderTemplateDataService = new Ftw.Dataservice.OrderTemplateDataservice();
        public OrderTemplateNewListName = ko.observable('');
        public OrderTemplateListVisible = ko.observable(false);
        public NewUserStatus = ko.observable('');
        public UserContactListVisible = ko.observable(false);
        public UserEditContactInfoVisible = ko.observable(false);
        public EditName = ko.observable('');
        public EditPhone = ko.observable('');
        public EditEmail = ko.observable('');
        public EditId = ko.observable('');

        public UserId = ko.observable('');


        constructor() {            
            super();
            //this.UserDataService.GetCurrent().then((user) => {
                
            //});
            this.UserDataService.GlobalInstanceUpdateOnSuccess = false;
            this.UserDataService.GetContacts().then((data) => {
                this.UserContacts(data);
            });
            this.OrderTemplateDataService.GetOrderTemplates().then((result) => {
                this.OrderTemplateList(result);
            });
            this.OrderTemplateNewListName.extend({
                required: true,
                minLength: 3
            });
            var Id = 0;
        }

        //function for editing user
        public editUser = (data: Ftw.Interfaces.IUser) => {
            this.EditName(data.Name());
            this.EditPhone(data.Phone());
            this.EditEmail(data.Email());
            this.EditId(data.Id());
        }

        //Function for saving edited user
        public SaveEditUser = (form) => {
            var data = $(form).serialize();

            this.data.postForm('/Handlers/Firstweb.ERP.Users.ashx?cmd=saveuser', data)
                .then((json) => {
                    if (json.ERPStatus.Code != 0) {
                        $('.status').removeClass('show');
                        $('.error-' + json.ERPStatus.Code).addClass('show');
                    } else {
                        $('#UserEdit').modal('hide');
                        $('.status').removeClass('show');
                        this.UserDataService.GetContacts().then((data) => {
                            this.UserContacts(data);
                        });
                    }
                }).fail(() => {
                    this.NewUserStatus('error');
              
                });
        }

        //Function for editing user info
        public save = (form) => {

            var data = $(form).serialize();
            this.data.postForm('/Handlers/Firstweb.ERP.Users.ashx?cmd=saveuser', data)
                .then((json) => {
                    if (json.ERPStatus.Code != 0) {
                        $('.status').removeClass('show');
                        $('.error-' + json.ERPStatus.Code).addClass('show');
                    } else {
                        $('.status').removeClass('show');
                        $('.userInfo').modal('hide');
                        this.NewUserStatus('success');
                        this.UserDataService.GetCurrent().then((user) => {
                            
                        });
                    }
                }).fail(() => {
                    this.NewUserStatus('error');
              
                });
        }

        //Function for making a new user
        //TODO : loading and finaly
        public makeNewUser = (form) => {

            var data = $(form).serialize();
            this.data.postForm('/Handlers/Firstweb.ERP.Users.ashx?cmd=createuser', data)
                .then((json) => {
                    var user = <Ftw.Interfaces.IUser>json.Data;
                    if (json.ERPStatus.Code != 0) {
                        $('.status').removeClass('show');
                        $('.error-' + json.ERPStatus.Code).addClass('show');
                    } else {
                        $('.status').removeClass('show');
                        this.UserDataService.GetContacts().then((data) => {
                            this.UserContacts(data);
                        });
                        $('#Users').modal('hide');
                        this.NewUserStatus('success');
                        $("#Users #EditForm input").val("");
                        $("#Users #EditForm #userid").val("0");
                    }
                }).fail(() => {
                    this.NewUserStatus('error');
              
                });
        }       

        public delete = (data: Ftw.Interfaces.IUser) => {
            this.NewUserStatus('confirmation');
            this.UserId(data.Id());
        }

        //Function for deleting a user
        //TODO : Loading animation and finaly
        public deleteUser = () => {
            this.data.get('/Handlers/Firstweb.ERP.Users.ashx?cmd=deleteuser&userid=' + this.UserId()).then(() => {
                this.UserDataService.GetContacts().then((data) => {
                    this.UserContacts(data);
                    this.NewUserStatus('success');
                }).fail(() => {
                    this.NewUserStatus('error');
                }).finally(() => {
                    
                });
            });
        }

        //Function for making a new list
        public makeNewList = () => {
            var listName = this.OrderTemplateNewListName();
            if (!this.OrderTemplateNewListName.isValid()) {
                return;
            }
            this.OrderTemplateDataService.CreateNewOrderTemplate(listName)
                .then((result) => {
                    this.OrderTemplateList.unshift(result);
                    $('.productListPopup').modal('hide');
                }).fail(() => {
                    this.NewUserStatus('error');
                });
        }
        public GetOrderTemplates(productId?: string) {
            this.OrderTemplateDataService.GetOrderTemplates(productId || '').then((result) => {
                this.OrderTemplateList(result);
            })
        }
        public GetOrderTemplateDetailLink(item: any): string {
            return this.OrderTemplateDetailsLink() + '&otid=' + item.Key();

        }
    }
}